import { useAuth } from './useAuth';

export const usePermissionCheck = () => {
  const {
    user,
    isPlatformAdmin,
    isAdmin,
    isOperador,
    isVisualizador,
    isTenant,
    isStandAlone,
  } = useAuth();

  // Derived permission checks - based on TipoUsuario and TenantTipo combinations

  // User management - only admins can manage users
  const canManageUsers = () => isAdmin();
  const canViewUsers = () => isAdmin();

  // Client management - only tenants with Admin or Operador can manage clients
  const canManageClients = () => isTenant() && (isAdmin() || isOperador());
  const canViewClients = () => isTenant();

  // Device management - Admin and Operador can manage, all can view
  const canManageDevices = () => isAdmin() || isOperador();
  const canViewDevices = () => true; // All authenticated users can view devices

  // Alert management - Admin and Operador can manage, all can view
  const canManageAlerts = () => isAdmin() || isOperador();
  const canViewAlerts = () => true; // All authenticated users can view alerts

  // Dashboard - all authenticated users can view
  const canViewDashboard = () => true;

  // Delete is split from manage because the backend DELETE endpoint enforces RequireAdmin,
  // while POST/PATCH/regenerate accept Operador.
  const model = user?.tenantTipo as string | undefined;
  const canManageInstallationTokens = () => (isAdmin() || isOperador()) &&
    ((isTenant() && (model === 'Msp' || model === 'Tenant')) || (model === 'Root' && isPlatformAdmin()));
  const canDeleteInstallationTokens = () => canManageInstallationTokens() && isAdmin();
  // Standalone e MultiTenant somente consultam; MSP/plataforma gerenciam.
  // Visualizador fica de fora: o GET de tokens exige Admin/Operador no backend, entao dar
  // canView a um StandAlone Visualizador abriria a pagina so pra colher 403 em cada request.
  const canViewInstallationTokens = () => !isVisualizador() && (isTenant() || isStandAlone() || canManageInstallationTokens());

  // Reset MFA of a client user: only Tenant Admin (security-sensitive bypass).
  const canResetClientMfa = () => isTenant() && isAdmin();

  return {
    // Base checks
    isPlatformAdmin,
    isAdmin,
    isOperador,
    isVisualizador,
    isTenant,
    isStandAlone,

    // Derived checks
    canManageUsers,
    canViewUsers,
    canManageClients,
    canViewClients,
    canManageDevices,
    canViewDevices,
    canManageAlerts,
    canViewAlerts,
    canViewDashboard,
    canManageInstallationTokens,
    canDeleteInstallationTokens,
    canViewInstallationTokens,
    canResetClientMfa,
  };
};

export default usePermissionCheck;
